type Interval = {
  tag: string;
};

export const getFilteredTransactionIntervals = (intervals: Interval[]) =>
  intervals.filter(({ tag }) => !['year', 'half_year'].includes(tag));
